import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const AlldatatblAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		business_name: yup.string().nullable().label("Business Name"),
		first_name: yup.string().nullable().label("First Name"),
		last_name: yup.string().nullable().label("Last Name"),
		designation: yup.string().nullable().label("Designation"),
		mobile: yup.string().nullable().label("Mobile"),
		mobile_alt: yup.string().nullable().label("Mobile Alt"),
		email: yup.string().email().nullable().label("Email"),
		email_alt: yup.string().email().nullable().label("Email Alt"),
		templeteid: yup.string().nullable().label("Templeteid"),
		sent_total: yup.number().required().label("Sent Total"),
		states: yup.string().nullable().label("States"),
		pincode: yup.string().nullable().label("Pincode")
	});
	
	//form default values
	const formDefaultValues = {
		business_name: '', 
		first_name: '', 
		last_name: '', 
		designation: '', 
		mobile: '', 
		mobile_alt: '', 
		email: '', 
		email_alt: '', 
		templeteid: '', 
		sent_total: "((0))", 
		states: '', 
		pincode: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/alldatatbl`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="AlldatatblAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Alldata Tbl"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Business Name 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="business_name"  onChange={formik.handleChange}  value={formik.values.business_name}   label="Business Name" type="text" placeholder="Enter Business Name"        className={inputClassName(formik?.errors?.business_name)} />
                                                <ErrorMessage name="business_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                First Name 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="first_name"  onChange={formik.handleChange}  value={formik.values.first_name}   label="First Name" type="text" placeholder="Enter First Name"        className={inputClassName(formik?.errors?.first_name)} />
                                                <ErrorMessage name="first_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Last Name 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="last_name"  onChange={formik.handleChange}  value={formik.values.last_name}   label="Last Name" type="text" placeholder="Enter Last Name"        className={inputClassName(formik?.errors?.last_name)} />
                                                <ErrorMessage name="last_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Designation 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="designation"  onChange={formik.handleChange}  value={formik.values.designation}   label="Designation" type="text" placeholder="Enter Designation"        className={inputClassName(formik?.errors?.designation)} />
                                                <ErrorMessage name="designation" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Mobile 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobile"  onChange={formik.handleChange}  value={formik.values.mobile}   label="Mobile" type="text" placeholder="Enter Mobile"        className={inputClassName(formik?.errors?.mobile)} />
                                                <ErrorMessage name="mobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Mobile Alt 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobile_alt"  onChange={formik.handleChange}  value={formik.values.mobile_alt}   label="Mobile Alt" type="text" placeholder="Enter Mobile Alt"        className={inputClassName(formik?.errors?.mobile_alt)} />
                                                <ErrorMessage name="mobile_alt" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Email 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="email"  onChange={formik.handleChange}  value={formik.values.email}   label="Email" type="email" placeholder="Enter Email"        className={inputClassName(formik?.errors?.email)} />
                                                <ErrorMessage name="email" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Email Alt 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="email_alt"  onChange={formik.handleChange}  value={formik.values.email_alt}   label="Email Alt" type="email" placeholder="Enter Email Alt"        className={inputClassName(formik?.errors?.email_alt)} />
                                                <ErrorMessage name="email_alt" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Templeteid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/templeteid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="templeteid"     optionLabel="label" optionValue="value" value={formik.values.templeteid} onChange={formik.handleChange} options={response} label="Templeteid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.templeteid)}   />
                                                    <ErrorMessage name="templeteid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Sent Total *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="sent_total"  onChange={formik.handleChange}  value={formik.values.sent_total}   label="Sent Total" type="number" placeholder="Enter Sent Total"  min={0}  step="any"    className={inputClassName(formik?.errors?.sent_total)} />
                                                <ErrorMessage name="sent_total" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                States 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="states"  onChange={formik.handleChange}  value={formik.values.states}   label="States" type="text" placeholder="Enter States"        className={inputClassName(formik?.errors?.states)} />
                                                <ErrorMessage name="states" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pincode 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pincode"  onChange={formik.handleChange}  value={formik.values.pincode}   label="Pincode" type="text" placeholder="Enter Pincode"        className={inputClassName(formik?.errors?.pincode)} />
                                                <ErrorMessage name="pincode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
AlldatatblAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'alldatatbl',
	apiPath: 'alldatatbl/add',
	routeName: 'alldatatbladd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default AlldatatblAddPage;
